export default "__VITE_ASSET__Bs1oZ$uj__"